module.exports = __webpack_public_path__ + "img/exclamation-circle-solid.248e8ee3.svg";